<button class="btn btn-outline-primary mb-1 mr-2" *ngFor="let ticket of tickets">
    <span [title]="jsonToNote(ticket)" class="font-weight-bold">{{ ticket.caption }}{{ getCallingTime(ticket) | date: 'HH:mm':'UTC' }}</span><br><span>{{ jsonToNoteShort(ticket) }}</span>
</button>
